import * as React from 'react'
import { useSnapshot } from 'valtio'
import { controlState } from '../../../store/controlState.ts'
import { clearRoute } from './directionHelper.tsx'

interface Props {
}

export const ClearDirectionsButton: React.FC<Props> = (props) => {
    const {} = props

    const visible = useSnapshot(controlState).directionsVisible

    const component = (
        <div className={'btn btn-lg btn-secondary'}
             onClick={() => {
                 clearRoute()
                 controlState.directionsVisible = false
             }}
        >
            Clear Directions
        </div>
    )

    return visible ? component : null
}